import { Helmet } from "react-helmet-async";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { Toaster } from "@/components/ui/sonner";
import { SITE, isPlaceholder } from "@/config/site";

const organizationJsonLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: SITE.name,
  description: SITE.description,
  ...(isPlaceholder(SITE.url) ? {} : { url: SITE.url }),
};

export const Layout = ({ children }) => {
  const hasGtm = !isPlaceholder(SITE.gtmContainerId);
  const hasGa = !isPlaceholder(SITE.ga4MeasurementId);

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(organizationJsonLd)}</script>
        {hasGtm && (
          <script>{`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${SITE.gtmContainerId}');`}</script>
        )}
        {hasGa && <script async src={`https://www.googletagmanager.com/gtag/js?id=${SITE.ga4MeasurementId}`}></script>}
        {hasGa && (
          <script>{`window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','${SITE.ga4MeasurementId}');`}</script>
        )}
      </Helmet>
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:z-50 focus:bg-brand-purple focus:px-4 focus:py-2 focus:text-white">
        Skip to content
      </a>
      <Header />
      <main id="main-content">{children}</main>
      <Footer />
      <Toaster />
    </>
  );
};
